import { mq } from '@hangar31/rc-layout';

/**
 * Hide a button's trailing label `<span>` on viewports below the md
 * breakpoint and rebalance the padding/icon offsets so the icon sits
 * centered instead of floating to the left of empty space.
 *
 * Apply via `css={iconOnlyOnMobileCss}` on a `<ButtonStyled withIcon>`
 * that wraps its label text in a `<span>`:
 *
 *   <ButtonStyled css={iconOnlyOnMobileCss} withIcon>
 *     <Icon name="..." tooltip="..." />
 *     <span>Label</span>
 *   </ButtonStyled>
 */
export const iconOnlyOnMobileCss = mq({
  '> span': { display: ['none', undefined, 'inline'] },

  i: {
    // withIcon nudges the icon left to butt against a label. With no
    // label that creates a lopsided gap on the right — zero out on
    // mobile only.
    marginLeft: ['0', undefined, '-1rem'],
    marginRight: ['0', undefined, '0.5rem'],
  },
  // Center the icon when it's the only visible content. Buttons are
  // sized by their inline content + padding, but the icon ships with
  // a built-in margin-right, so without explicit centering it ends up
  // left-of-center inside its own padding box.
  justifyContent: ['center', undefined, 'flex-start'],
  // Square padding on mobile (icon centered); restore the original
  // 0.9rem 2.7rem on tablet+ so the label has room.
  padding: ['0.9rem', undefined, '0.9rem 2.7rem'],

  textAlign: ['center', undefined, 'left'],
});
